var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('van-checkbox', _vm._g(_vm._b({
        ref: "checkbox",
        attrs: {
            "value": _vm.value,
            "shape": _vm.shape,
            "icon-size": _vm.iconSize
        },
        on: {
            "input": _setup.onInput
        }
    }, 'van-checkbox', _vm.$attrs, false), _vm.$listeners), [
        _vm._t("default")
    ], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };
